module.exports = __webpack_public_path__ + "static/media/sell_take_order_make_5.1457e09c.jpg";